"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var haversine_1 = __importDefault(require("haversine"));
var react_1 = require("react");
var cluster_radius_1 = require("./util/cluster-radius");
var create_cluster_1 = require("./util/create-cluster");
var map_component_1 = require("./map.component");
var map_types_1 = require("./map.types");
function calculateDistance(first, second) {
    return haversine_1.default(first, second, { unit: 'km' });
}
function shouldBeClustered(_a) {
    var radius = _a.radius, installation = _a.installation, otherInstallation = _a.otherInstallation;
    var distance = calculateDistance(installation.location, otherInstallation.location);
    return distance < radius && installation.type === map_types_1.MapInstallationType.INSTALLATION;
}
function useClusteredInstallations(installations) {
    var zoomFactor = react_1.useContext(map_component_1.MapContext).zoomFactor;
    return react_1.useMemo(function () {
        var mappedInstallations = installations.map(function (installation) { return (__assign(__assign({}, installation), { type: map_types_1.MapInstallationType.INSTALLATION })); });
        if (!cluster_radius_1.clusterRadius[zoomFactor])
            return mappedInstallations;
        var stackOfInstallations = __spreadArrays(mappedInstallations);
        var isInCluster = {};
        var clusteredInstallations = [];
        var _loop_1 = function () {
            var installation = stackOfInstallations.pop();
            if (!installation)
                return { value: clusteredInstallations };
            stackOfInstallations.forEach(function (otherInstallation) {
                if (isInCluster[installation.id] ||
                    isInCluster[otherInstallation.id] ||
                    !shouldBeClustered({ radius: cluster_radius_1.clusterRadius[zoomFactor], installation: installation, otherInstallation: otherInstallation }))
                    return;
                if (otherInstallation.type === map_types_1.MapInstallationType.INSTALLATION) {
                    var installationsInCluster = [installation, otherInstallation];
                    var cluster = create_cluster_1.createCluster(zoomFactor, installationsInCluster);
                    stackOfInstallations.unshift(cluster);
                    isInCluster[installation.id] = true;
                    isInCluster[otherInstallation.id] = true;
                    clusteredInstallations.push(cluster);
                }
                else if (otherInstallation.type === map_types_1.MapInstallationType.CLUSTER) {
                    var otherInstallationCluster = otherInstallation;
                    otherInstallationCluster.installationsInCluster.push(installation);
                    isInCluster[installation.id] = true;
                }
            });
            if (!isInCluster[installation.id] && installation.type === map_types_1.MapInstallationType.INSTALLATION)
                clusteredInstallations.push(installation);
        };
        while (stackOfInstallations.length > 0) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return clusteredInstallations;
    }, [installations, zoomFactor]);
}
exports.default = useClusteredInstallations;
